import { gql } from '@apollo/client'

export const UPDATE_KETO_MOJO_DATA = gql`
  mutation updateKetoMojoData($data: [KetoMojoData!]!) {
    updateKetoMojoData(data: $data) {
      success
    }
  }
`
